<div class="sos-content" *ngIf="hasObservacao()">
    <h4>Observação</h4>
    <textarea class="form-control" maxlength="500" rows="5" cols="50" [(ngModel)]="observacaoSos" name="observacao" #observacaoInput="ngModel"
      required> </textarea>
    <div *ngIf="isObsObrigatorio" class="alert alert-danger alert-dismissable">
      <strong>Observação é obrigatório</strong>
    </div>
</div>
